// 環境別URL設定
const config = {
  // 運用環境のURL設定
  production: {
    // アプリケーション自体のURL
    appUrl: "https://sendaimeibanpfdebug.z11.web.core.windows.net/", // 運用環境のURL（例）
    // メニューリンクのURL
    urls: {
      recordCH: "https://sendai:s-meiban001@densho-bato.com/member/new_ui/kc/JP/latest.html",
      fieldWeb: "https://strsignage.blob.core.windows.net/kaneko-test/genbaPageDemo.html",
      vehicleRecord: "https://sendaimeibanpfdeploy.z11.web.core.windows.net/ss/vehicle-record",
      snowMelter: "https://nexcoyakueki00stage.z11.web.core.windows.net/",
    shipmentManager: "/SCManager", // 出荷管理の相対URL
      guardNavi: "https://guardnavidataviewer.blob.core.windows.net/0001/index.html", // ガードナビデータ表示URL追加
      batteryCheck: "https://sensordataviewer.z7.web.core.windows.net/", // バッテリーチェックURL追加
      imageAnalysis: "https://recovision.z11.web.core.windows.net/" // 画像解析URL追加
    }
  },
  // 開発環境のURL設定
  development: {
    // アプリケーション自体のURL
    appUrl: "http://localhost:3011", // 開発環境のURL
    // メニューリンクのURL
    urls: {
      recordCH: "https://sendai:s-meiban001@densho-bato.com/member/new_ui/kc/JP/latest.html",
      fieldWeb: "https://strsignage.blob.core.windows.net/kaneko-test/genbaPageDemo.html",
      vehicleRecord: "https://sendaimeibanpfdeploy.z11.web.core.windows.net/ss/vehicle-record",
      snowMelter: "https://nexcoyakueki00stage.z11.web.core.windows.net/",
    shipmentManager: "/SCManager", // 出荷管理の相対URL
      guardNavi: "https://guardnavidataviewer.blob.core.windows.net/0001/index.html", // ガードナビデータ表示URL追加
      batteryCheck: "https://sensordataviewer.z7.web.core.windows.net/", // バッテリーチェックURL追加
      imageAnalysis: "https://recovision.z11.web.core.windows.net/" // 画像解析URL追加
    }
  }
};

// 現在の環境に基づいて設定を取得
const currentEnv = process.env.NODE_ENV === 'production' ? config.production : config.development;

export default currentEnv;
